module.exports = __webpack_public_path__ + "img/07_Lichtwirkung-Tabelle.c8d0c3a2.svg";